import {
  type BaseField,
  Calendar,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormMessage,
  Select,
  withConditional,
} from "@bleu.builders/ui";
import { getYear, getMonth } from "date-fns";
import React from "react";

export interface DatePickerInputProps extends BaseField {
  type: "year_calendar" | "year_calendar_time";
}

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const years = Array.from(
  { length: 111 },
  (_, i) => getYear(new Date()) - 100 + i
);

export const DatePickerInput = withConditional<DatePickerInputProps>(
  ({ form, field }) => {
    const isDatetime = field.type === "year_calendar_time";
    const [selectedDate, setSelectedDate] = React.useState<Date>(() => {
      if (field.defaultValue) return new Date(field.defaultValue);
      if (form.getValues(field.name))
        return new Date(form.getValues(field.name));
      return new Date();
    });

    const handleMonthChange = (month: string) => {
      const newDate = new Date(selectedDate);
      newDate.setMonth(months.indexOf(month));
      setSelectedDate(newDate);
      form.setValue(field.name, newDate);
    };

    const handleYearChange = (year: string) => {
      const newDate = new Date(selectedDate);
      newDate.setFullYear(Number.parseInt(year));
      setSelectedDate(newDate);
      form.setValue(field.name, newDate);
    };

    const handleDateSelect = (date: Date | undefined) => {
      if (date) {
        setSelectedDate(date);
      }
    };

    return (
      <FormField
        control={form.control}
        name={field.name}
        rules={field.required ? { required: true } : undefined}
        defaultValue={field.defaultValue}
        render={({ field: formField }) => (
          <FormItem className="flex flex-col w-full">
            <div className="flex flex-1 justify-between gap-2 mb-4">
              <Select.SelectRoot
                value={months[getMonth(selectedDate)]}
                onValueChange={handleMonthChange}
              >
                <Select.SelectTrigger className="w-[140px]">
                  <Select.SelectValue placeholder="Month" />
                </Select.SelectTrigger>
                <Select.SelectContent>
                  {months.map((month) => (
                    <Select.SelectItem key={month} value={month}>
                      {month}
                    </Select.SelectItem>
                  ))}
                </Select.SelectContent>
              </Select.SelectRoot>

              <Select.SelectRoot
                value={getYear(selectedDate).toString()}
                onValueChange={handleYearChange}
              >
                <Select.SelectTrigger className="w-[100px]">
                  <Select.SelectValue placeholder="Year" />
                </Select.SelectTrigger>
                <Select.SelectContent>
                  {years.map((year) => (
                    <Select.SelectItem key={year} value={year.toString()}>
                      {year}
                    </Select.SelectItem>
                  ))}
                </Select.SelectContent>
              </Select.SelectRoot>
            </div>

            <FormControl>
              {/* @ts-expect-error TS(2739) FIXME: Type '{ mode: string; selected: any; onSelect: any... Remove this comment to see the full error message */}
              <Calendar
                mode="single"
                selected={formField.value}
                onSelect={(date: Date | undefined) => {
                  formField.onChange(date);
                  handleDateSelect(date);
                }}
                month={selectedDate}
                onMonthChange={setSelectedDate}
                withTime={isDatetime}
                initialFocus
                className="rounded-md border"
              />
            </FormControl>
            <FormDescription>{field.description}</FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    );
  }
);
